import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import vf_logo from "../assets/logo.svg";

function Header() {
  const [isSticky, setSticky] = useState(false);
  const spacerRef = useRef(null);

  const handleScrollEvent = () => {
    const ref = spacerRef.current;
    if (ref) {
      const pageYOffset = window.pageYOffset;
      const offset = ref.offsetTop || ref.parentElement?.offsetTop;
      const isSticky = pageYOffset > offset;
      setSticky(isSticky);
    }
  };

  function onHeaderClick() {
    window.location.href = process.env.REACT_APP_REDIRECT_URI;
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScrollEvent);
    return () => window.removeEventListener("scroll", handleScrollEvent);
  }, []);

  return (
    <div>
      {<div className={isSticky ? "spacer" : "hidden"} ref={spacerRef} />}
      <div className={isSticky ? "sticky" : ""}>
        <div className="headerContainer" onClick={onHeaderClick}>
          <div className="headerMaxWidth">
            <img className="vf_logo_img" src={vf_logo} alt="VF logo" />
            <div className="headerTitle"> Vodafone Identity Hub</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Header);
